<template>
  <div
    v-if="(isReserved || isSold) && adv.lot_data.nature === 'field'"
    style="position: relative;">
    <div class="is-border-top has-background-white is-border-left is-border-right">
      <div class="has-background-white is-padding-left is-padding-right is-padding-top-small is-padding-bottom-small">
        <span class="is-uppercase title is-6">Construction</span>
      </div>
    </div>
    <div
      class="is-border-top">
      <div v-if="adv.permis && adv.permis.length">
        <div
          v-for="(permis, i) in adv.permis"
          :key="i"
          :class="i % 2 === 0 ? 'has-background-white' : 'has-background-light'"
          class="columns is-multiline is-padding is-marginless">
          <div class="column is-7">
            <r-label
              :label="'Numéro du permis'"
              :is-required="false" />
            <v-input
              :id="'permis_number' + i"
              :name="'permis_number' + i"
              :model="permis.number"
              data-vv-as="Numéro du permis"
              :errors-bag="errors"
              data-vv-value-path="val"
              @input="permis.number = $event; commitToStore()" />
          </div>
          <div class="column is-5">
            <r-label
              :label="'Désignation'"
              :is-required="false" />
            <div class="control">
              <v-input
                :has-addons="true"
                :id="'permis_name' + i"
                name="permis_name"
                :model="permis.name"
                data-vv-as="Désignation"
                :errors-bag="errors"
                data-vv-value-path="val"
                @input="permis.name = $event; commitToStore()">
                <p
                  class="control"
                  slot="addonRight">
                  <a
                    @click="deleteItem(i, adv.permis)"
                    class="button is-square is-grey is-inverted is-border">
                    <span class="icon"><i class="fal fa-trash-alt fa-lg"></i></span>
                  </a>
                </p>
              </v-input>
            </div>
          </div>
          <div
            class="column is-4">
            <date-picker
              :model="permis.deposit_date"
              :style-version="2"
              @input="permis.deposit_date = $event; commitToStore()"
              label="Date de dépôt permis"
              :is-required="true"></date-picker>
            <label class="label"></label>
          </div>
          <div
            class="column is-4">
            <date-picker
              :model="permis.agreement_date"
              :style-version="2"
              @input="permis.agreement_date = $event; commitToStore()"
              label="Date accord permis"
              :is-required="false"></date-picker>
            <label class="label"></label>
          </div>
        </div>
      </div>
      <div
        class="is-flex-center is-size-3 is-padding-top-large is-padding-bottom-large has-background-white"
        v-else>
        <!-- <span class="icon"><i class="fas fa-engine-warning"></i></span> -->
        <span class="is-margin-left-small">Aucun permis</span>
      </div>
      <div
        @click="addNewPermis()"
        class="column is-12 has-cursor-pointer columns is-paddingless is-marginless">
        <span class="column is-12 has-background-primary has-text-centered has-text-white is-padding-top-small is-padding-bottom-small is-uppercase">Ajouter un permis</span>
      </div>
    </div>
    <div
      class="is-border-top is-margin-top">
      <div v-if="adv.intermediary && adv.intermediary.length">
        <div
          v-for="(intermediary, i) in adv.intermediary"
          :key="i"
          :class="i % 2 === 0 ? 'has-background-white' : 'has-background-light'"
          class="columns is-multiline is-padding is-marginless">
          <div class="column is-4">
            <r-label
              :label="'Société'"
              :is-required="false" />
            <v-input
              :id="'society_name' + i"
              :name="'society_name' + i"
              :model="intermediary.society"
              data-vv-as="Société"
              :errors-bag="errors"
              data-vv-value-path="val"
              @input="intermediary.society = $event; commitToStore()" />
          </div>
          <div class="column is-4">
            <r-label
              :label="'Nom'"
              :value="intermediary.name"
              :is-required="true" />
            <v-input
              :id="'intermediary_name' + i"
              :name="'intermediary_name' + i"
              :model="intermediary.name"
              data-vv-as="Société"
              :errors-bag="errors"
              data-vv-value-path="val"
              @input="intermediary.name = $event; commitToStore()" />
          </div>
          <div class="column is-4">
            <r-label
              :label="'Rôle'"
              :is-required="false" />
            <div class="control">
              <v-input
                :has-addons="true"
                :id="'role' + i"
                :name="'role' + i"
                :model="intermediary.role"
                data-vv-as="Rôle"
                :errors-bag="errors"
                data-vv-value-path="val"
                @input="intermediary.role = $event; commitToStore()">
                <p
                  class="control"
                  slot="addonRight">
                  <a
                    @click="deleteItem(i, adv.intermediary)"
                    class="button is-square is-grey is-inverted is-border">
                    <span class="icon"><i class="fal fa-trash-alt fa-lg"></i></span>
                  </a>
                </p>
              </v-input>
            </div>
          </div>
          <div class="column is-4">
            <r-label
              :label="'Téléphone'"
              :is-required="false" />
            <v-input
              :id="'intermediary_phone' + i"
              :name="'intermediary_phone' + i"
              :model="intermediary.phone"
              data-vv-as="Téléphone"
              :errors-bag="errors"
              data-vv-value-path="val"
              @input="intermediary.phone = $event; commitToStore()" />
          </div>
          <div class="column is-4">
            <r-label
              :label="'Email'"
              :is-required="false" />
            <v-input
              :id="'intermediary_email' + i"
              :name="'intermediary_email' + i"
              :model="intermediary.email"
              data-vv-as="Email"
              :errors-bag="errors"
              data-vv-value-path="val"
              @input="intermediary.email = $event; commitToStore()" />
          </div>
        </div>
      </div>
      <div
        class="is-flex-center is-size-3 is-padding-top-large is-padding-bottom-large has-background-white"
        v-else>
        <!-- <span class="icon"><i class="fas fa-engine-warning"></i></span> -->
        <span class="is-margin-left-small">Aucun contact</span>
      </div>
      <div
        @click="addNewIntermediary()"
        class="column is-12 has-cursor-pointer columns is-paddingless is-marginless">
        <span class="column is-12 has-background-primary has-text-centered has-text-white is-padding-top-small is-padding-bottom-small is-uppercase">Ajouter un contact</span>
      </div>
    </div>
    <div
      v-if="isAdmin && isPromoteur || currentUser.active_all_contact"
      class="has-background-white is-border-top is-margin-top">
      <div class="row-width-actions-bar columns is-gapless is-marginless">
        <div class="column is-self-centered is-padding-left is-padding-top-xsmall is-padding-bottom-xsmall">
          <span class="is-uppercase title is-6">Commentaire</span>
        </div>
        <div class="column is-narrow is-border-left">
        </div>
      </div>
      <template v-if="openComment">
        <div
          v-if="!openCommentWysi && comment"
          @click="openWysiwyg"
          class="vadDiscussion is-border-top"
          style="cursor: pointer;">
          <div
            class="vadDiscussion--bulle is-size-6 is-minH50p vadDiscussion--bulle--has-actions is-cut is-padding-left">
            <div
              class="content"
              v-if="(isAdmin || currentUser.active_all_contact) && comment"
              v-html="comment"></div>
            <div class="actionsOnRow actionsOnRow--vertical">
              <div class="">
                <button
                  @click="openWysiwyg"
                  class="is-min-height-full">
                  <span class="icon is-small"><i class="fal fa-edit"></i></span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else
          class="is-border-top columns is-gapless">
          <div class="column">
            <wysiwyg-editor
              :light="true"
              :tooltip-top="true"
              :model="comment"
              @change="val => comment = val"
              class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
            </wysiwyg-editor>
          </div>
          <div class="actionsOnRow actionsOnRow--vertical">
            <div>
              <button
                @click="patchComment()"
                type="button"
                class="button"
                :class="[(baseComment !== comment) ? 'is-success' : 'is-info']"
                :disabled="(baseComment === comment)">
                <span class="icon is-small">
                  <i
                    v-if="loadComment"
                    class="fas fa-spinner fa-spin"></i>
                  <i
                    v-else
                    class="fal fa-save"></i>
                </span>
              </button>
            </div>
            <div class="">
              <button
                :disabled="!baseComment"
                type="button"
                :class="{'actionsOnRow-btn--hoverIsDanger': comment}"
                @click="comment?openCommentWysi = false:null; comment = baseComment">
                <span class="icon is-small"><i class="fal fa-times"></i></span>
              </button>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { DefaultValues, Adv, Upload } from '@/mixins'
import { cloneDeep } from 'lodash'

export default {
  name: 'Construction',
  mixins: [DefaultValues, Adv, Upload],
  data () {
    return {
      emptyPermis: {
        number: null,
        name: null,
        deposit_date: null,
        agreement_date: null,
        pk: null
      },
      emptyIntermediary: {
        role: null,
        society: null,
        name: null,
        phone: null,
        email: null,
        pk: null
      }
    }
  },
  mounted () {
    if (!this.adv.permis) this.adv.permis = []
    if (!this.adv.intermediary) this.adv.intermediary = []
  },
  methods: {
    commitToStore () {
      this.$store.commit('modifyCurrentAdv', { key: `permis`, value: this.adv.permis })
      this.$store.commit('modifyCurrentAdv', { key: `intermediary`, value: this.adv.intermediary })
    },
    deleteItem (index, list) {
      if (index !== -1) {
        list.splice(index, 1)
        this.commitToStore()
      }
    },
    addNewPermis () {
      let newPermis = cloneDeep(this.emptyPermis)
      this.adv.permis.push(newPermis)
    },
    addNewIntermediary () {
      let newIntermediary = cloneDeep(this.emptyIntermediary)
      this.adv.intermediary.push(newIntermediary)
    }
  }
}
</script>
